import { hasCookies } from "./cookies";
import { imageUpload } from "../redux/apis/productAPI";
import { findObjectInArray } from "./object";

const redirectTo404 = () => {
  if (window.location.pathname !== "/404") {
    window.location.replace("/404");
  }
};

export const isNull = (str) => {
  if (str === "" || str === null || str === undefined) {
    return true;
  }
  return false;
};

export const isObject = (data) => {
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};

export const isValidCheckoutPage = (checkoutState) => {
  try {
    const searchParams = window.location.search;
    const id = searchParams.split("=")[1];
    const valid = hasCookies(id, checkoutState);
    if (!valid) {
      redirectTo404();
    } else {
      return true;
    }
  } catch (e) {
    console.error("CHeckout page validation error:", e);
    redirectTo404();
  }
};

export const validateForm = (data, ignoreList = []) => {
  const ignoredFields = new Set(ignoreList || []);
  const ignoredPaths = Array.from(ignoredFields);

  const shouldIgnore = (key, currentPath) => {
    if (ignoredFields.has(key) || ignoredFields.has(currentPath)) {
      return true;
    }

    for (const ignoredPath of ignoredPaths) {
      if (currentPath.startsWith(`${ignoredPath}.`)) {
        return true;
      }
    }

    return false;
  };

  if (data.dateEvent) {
    const isDateHandGreaterThanDateEvent =
      new Date(data.dateHand) > new Date(data.dateEvent);

    if (isDateHandGreaterThanDateEvent) {
      return "In Hand Date should be smaller or equal to Event Date";
    }
  }

  const stack = [{ obj: data, path: "" }];

  while (stack.length > 0) {
    const { obj, path } = stack.pop();

    for (const key in obj) {
      const currentPath = path ? `${path}.${key}` : key;
      const value = obj[key];

      if (shouldIgnore(key, currentPath)) {
        continue;
      }

      if (value !== null && typeof value === "object") {
        stack.push({ obj: value, path: currentPath });
        continue;
      }

      if (
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "")
      ) {
        return `${currentPath} field is invalid`;
      }
    }
  }

  return true;
};


export const isValidBibStartandEnd = (start, end) => {
  if (isNull(start) || isNull(end)) {
    return false;
  }
  if (end > 0 && Number(end) - Number(start) > 0) {
    return true;
  }
  return false;
};

export const checkCustomImage = async (v) => {
  let validImage = true;
  await Promise.all(
    v.map(async (item) => {
      if (item["Upload Logo"] && Array.isArray(item["Upload Logo"])) {
        if (item["Upload Logo"].length > 0 && item["Upload Logo"][0].name) {
          return true;
        }
        await Promise.all(
          item["Upload Logo"].map(async (vi) => {
            if (vi.image) {
              if (vi.image instanceof File) {
                vi.image = await imageUpload(vi.image);
                if (vi.image == "") {
                  validImage = false; //upload error
                }
              }
              if (vi.base64) {
                delete vi.base64;
              }
            } else {
              validImage = false; // Mark invalid if image is missing
            }
          })
        );
      }
    })
  );
  return validImage;
};

export const checkCustomText = async (v) => {
  let validText = true;
  v.map(async (item) => {
    if (item["Add Text"] && Array.isArray(item["Add Text"])) {
      item["Add Text"].map(async (vi) => {
        if (vi.text) {
          if (vi.text === "" || vi.text === undefined) {
            validText = false;
          }
        } else {
          validText = false;
        }
      });
    }
  });
  return validText;
};

export const isValidInteger = (value, max) => {
  if (value < 0 || value > (max ?? 999999)) {
    return false;
  }
  return true;
};

export const isValidAddress = (address) => {
  for (const key in address) {
    if (Object.hasOwn(address, key)) {
      const value = address[key];

      if (isNull(value)) {
        return {
          valid: false,
          invalidField: key,
        };
      }
    }
  }

  return {
    valid: true,
    invalidField: null,
  };
};

export const isValidCard = (cardNo) => {
  try {
    const cleaned = cardNo.replace(/\s/g, "");
    if (!/^\d{13,19}$/.test(cleaned)) return false;
    
    let sum = 0;
    let isEven = false;
    for (let i = cleaned.length - 1; i >= 0; i--) {
      let digit = parseInt(cleaned.charAt(i), 10);
      if (isEven) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }
      sum += digit;
      isEven = !isEven;
    }
    return sum % 10 === 0;
  } catch (e) {
    return false;
  }
};

export const isValidPrintColor = (v) => {
  const validPrintColor = findObjectInArray(v, "Print Colour");
  if (validPrintColor === " ") {
    return "Must choose one print colour";
  }

  let valid = true;
  const blackColor = "[0,0,0,100]";
  const whiteColor = "[0,0,0,0]";
  const blackColorText = "black";
  const whiteColorText = "white";

  v.map((item) => {
    if (Array.isArray(item["Add Text"])) {
      item["Add Text"].map((t) => {
        if (isNull(t.colour)) {
          valid = "Text colour is invalid.";
        } else {
          if (
            validPrintColor != "Full-colour" &&
            t.colour.toLowerCase() != blackColorText &&
            t.colour.toLowerCase() != whiteColorText
          ) {
            valid =
              "Colour was selected for text. Choose Full-colour under Print Colour or change text colour to black.";
          }
        }
      });
    }
  });

  return valid;
};
